import { Flex } from '@mantine/core';
import styled from 'styled-components';

export const PreviewWrapper = styled(Flex).attrs(() => ({
	direction: 'column',
	miw: '60%',
	gap: 0,
}))`
	flex-grow: 2;
	height: 100%;
	overflow: hidden;
`;

export const PreviewHeaderBar = styled(Flex).attrs(() => ({
	align: 'center',
	justify: 'space-between',
	px: 'sm',
	py: 'xs',
	gap: 'sm',
}))`
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	background: transparent;
`;

export const PreviewHeaderControls = styled(Flex).attrs(() => ({
	align: 'center',
	gap: '1.25rem',
}))``;

export const PreviewHeaderPageBox = styled.div`
	display: flex;
	align-items: center;
	gap: 0.25rem;
`;

export const PreviewBody = styled(Flex).attrs(() => ({
	h: '100%',
	w: '100%',
}))`
	flex: 1;
	overflow: hidden;
`;
